import React, { useState, useEffect } from "react";
import { useParams,useNavigate,Link } from 'react-router-dom';
import axios from 'axios';

import HeaderTitle from "../../components/includes/HeaderTitle";

import { isEmptyObj,ChangeMobileFormat,ChangeMobileNumber,removeThousandPoint,addThousandPoint } from "../../../components/common/Common";

//건의 정보 편집
function CustomerDetail({setMenuType,setMenuItem}) {
  const admin_idx = Number(localStorage.getItem('adminIdx'));
  let { cs_idx } = useParams();
  const navigator = useNavigate();

  //건의 변수 저장 객체
  const newData = {      
    cs_idx: 0,
    cs_mem_idx:admin_idx,
    cs_code: "",
    cs_name: "",
    cs_email: "",
    cs_ceo: "",
    cs_sectors: "",
    cs_items: "",
    cs_mobile: "",
    cs_address: "",
    cs_post_address:""
  };
  const newLine = {csl_idx:0,cs_idx:Number(cs_idx),csl_riding_name:"",csl_riding_address:"",csl_middle_name:"",csl_middle_address:"",
              csl_quit_name:"",csl_quitaddress:"",csl_cost:0};

  //건의정보
  const [varCustomerInfo,setCustomerInfo] = useState({});
  //노선
  const [varCustomerLineInfo,setCustomerLineInfo] = useState({});
  const [varCustomerLines,setCustomerLines] = useState([]);

  //건의정보 읽어오기
  const getCustomerInformation = async () => {
    var sendData = {cs_idx: cs_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_customer_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(datas.results?.length > 0) {
          setCustomerInfo(datas.results[0]);
        }
        if(datas.lines?.length > 0) {
          setCustomerLines(datas.lines);
        }
      }
    });
  }

  //페이지 정보 표시 - 최초
  useEffect(() => {
    setMenuType('DELIVERY');
    setMenuItem('CustomerList');
    setCustomerLineInfo(newLine);
    setCustomerInfo(newData);
    getCustomerInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //거래처정보편집
  const onCustomerInfoHandler = (e) => {
    const {name,value} = e.currentTarget;
    if(name === "cs_mobile") {
      setCustomerInfo({...varCustomerInfo, [name]:ChangeMobileNumber(value)});
    } else {
      setCustomerInfo({...varCustomerInfo, [name]:value});
    }
  }

  //건의정보 저장
  const onUpdateCustomerHandler = async (e) => {
    if(varCustomerInfo.cs_name === "") {
      alert('거래처명을 먼저 입력하세요'); return false;
    } else if(varCustomerInfo.cs_code === "") {
      alert('거래처코드를 먼저 입력하세요'); return false;
    } else if(varCustomerInfo.cs_ceo === "") {
      alert('거래처 대표자명을 먼저 입력하세요'); return false;
    /* } else if(varCustomerInfo.cs_email === "") {
      alert('이메일주소를 먼저 입력하세요'); return false; 
    } else if(!checkEmailString(varCustomerInfo.cs_email)) {
      alert('입력한 이메일주소의 형식이 맞지않습니다. 확인후 다시 입력하세요'); return false;*/
    } else if(varCustomerInfo.cs_sectors === "") {
      alert('업태를 먼저 입력하세요'); return false;
    } else if(varCustomerInfo.cs_items === "") {
      alert('종목을 먼저 입력하세요'); return false;
    } else if(varCustomerInfo.cs_address === "") {
      alert('사업자주소를 먼저 입력하세요'); return false;
    } else if(varCustomerInfo.cs_post_address === "") {
      alert('우편주소를 먼저 입력하세요'); return false;
    } else if(varCustomerInfo.cs_mobile === "") {
      alert('연락처를 먼저 입력하세요'); return false;
    }

    let prompt = "현재 입력된 거래처 정보를 저장합니까?";
    if(varCustomerInfo.cs_idx === 0)  prompt = "입력하신 거래처 정보를 등록합니까?";
    if(!window.confirm(prompt)) return false;

    const sendData = {dataInfo:varCustomerInfo};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_update_customer_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      alert(datas.message);
      if(datas.retvalue === 1) {
        //목록페이지로 이동
        navigator(`/Admin/CustomerList`);
      }
    });
  }

  //노선
  //거래처 노선 정보편집
  const onCustomerLineInfoHandler = (e) => {
    const {name,value} = e.currentTarget;
    if(name === "csl_cost") {
      let svalue = removeThousandPoint(value);
      setCustomerLineInfo({...varCustomerLineInfo, [name]:svalue});
    } else {
      setCustomerLineInfo({...varCustomerLineInfo, [name]:value});
    }
  }
  const onUpdateCustomerLineHandler = async(e) => {
    let newItem = 0;
    if(varCustomerLineInfo.csl_idx === 0) newItem = 1;
    const sendData = {dataInfo:varCustomerLineInfo};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_update_customer_line_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      alert(datas.message);
      if(datas.retvalue === 1) {
        let copyLines = [...varCustomerLines];
        if(newItem){
          let addLines = {...varCustomerLineInfo};
          addLines.csl_idx = datas.csl_idx;
          setCustomerLines(varCustomerLines.concat(addLines));
        } else {
          const csl_idx = varCustomerLineInfo.csl_idx;
          const findIndex = copyLines.findIndex(el=>el.csl_idx===csl_idx);
          copyLines[findIndex].csl_riding_name = varCustomerLineInfo.csl_riding_name;
          copyLines[findIndex].csl_riding_address = varCustomerLineInfo.csl_riding_address;
          copyLines[findIndex].csl_middle_name = varCustomerLineInfo.csl_middle_name;
          copyLines[findIndex].csl_middle_address = varCustomerLineInfo.csl_middle_address;
          copyLines[findIndex].csl_quit_name = varCustomerLineInfo.csl_quit_name;
          copyLines[findIndex].csl_quit_address = varCustomerLineInfo.csl_quit_address;
          copyLines[findIndex].csl_cost = varCustomerLineInfo.csl_cost;
          setCustomerLines(copyLines);
        }
        //노선 입력창 초기화
        setCustomerLineInfo(newLine);
      }
    });
    setCustomerLineInfo(newLine);
  }
  const onEditCustomerLineHandler = (e,csl_idx) => {
    const EditData = varCustomerLines.filter(el=>el.csl_idx===csl_idx);
    if(EditData?.length > 0) {
      setCustomerLineInfo(EditData[0]);
    }
  }
  const onDeleteCustomerLineHandler = async(e,csl_idx) => {
    if(varCustomerInfo.csl_idx === 0) {
      alert('삭제할 노선이 선택되어 있지 않습니다.');
    }
    if(!window.confirm('노선을 삭제합니까?')) return false;

    const sendData = {csl_idx:csl_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_delete_customer_line_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      alert(datas.message);
      if(datas.retvalue === 1) {
        const EditData = varCustomerLines.filter(el=>el.csl_idx!==csl_idx);
        setCustomerLineInfo(EditData);
      }
    });
  }
  
  return isEmptyObj(varCustomerInfo)?null:(
    <div id="admin_contents" className="ad_contents">
      <HeaderTitle varMenuTitle="배차관리" varPageTitle={varCustomerInfo.cs_idx===0?"거래처등록":"거래처상세"} />
      <div className="admin-content">
        <div>
          <h2 style={{fontSize:"16px",marginBottom:"10px"}}>거래처 정보</h2>
          <div className="main-box">
            <table className="write">
              <colgroup>
                <col width="20%"></col>
                <col width="80%"></col>
              </colgroup>
              <thead></thead>
              <tbody>
                <tr>
                  <th>거래처명</th>
                  <td><input type="text" name="cs_name" value={varCustomerInfo.cs_name} style={{width:"300px"}} onChange={(e)=>onCustomerInfoHandler(e)}/></td>
                </tr>
                <tr>
                  <th>거래처코드</th>
                  <td><input type="text" name="cs_code" value={varCustomerInfo.cs_code} style={{width:"300px"}} onChange={(e)=>onCustomerInfoHandler(e)}/></td>
                </tr>
                <tr>
                  <th>대표자명</th>
                  <td><input type="text" name="cs_ceo" value={varCustomerInfo.cs_ceo} style={{width:"200px"}} onChange={(e)=>onCustomerInfoHandler(e)}/></td>
                </tr>
                <tr>
                  <th>이메일</th>
                  <td><input type="text" name="cs_email" value={varCustomerInfo.cs_email} style={{width:"70%"}} onChange={(e)=>onCustomerInfoHandler(e)}/></td>
                </tr>
                <tr>
                  <th>업태</th>
                  <td><input type="text" name="cs_sectors" value={varCustomerInfo.cs_sectors} style={{width:"50%"}} onChange={(e)=>onCustomerInfoHandler(e)}/></td>
                </tr>
                <tr>
                  <th>종목</th>
                  <td><input type="text" name="cs_items" value={varCustomerInfo.cs_items} style={{width:"50%"}} onChange={(e)=>onCustomerInfoHandler(e)}/></td>
                </tr>
                <tr>
                  <th>사업자주소</th>
                  <td><input type="text" name="cs_address" value={varCustomerInfo.cs_address} onChange={(e)=>onCustomerInfoHandler(e)}/></td>
                </tr>
                <tr>
                  <th>우편주소</th>
                  <td><input type="text" name="cs_post_address" value={varCustomerInfo.cs_post_address} onChange={(e)=>onCustomerInfoHandler(e)}/></td>
                </tr>
                <tr>
                  <th>연락처</th>
                  <td><input type="text" name="cs_mobile" value={ChangeMobileFormat(varCustomerInfo.cs_mobile)} style={{width:"300px"}} onChange={(e)=>onCustomerInfoHandler(e)}/></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="btn-center">
            <button className="btn line black" style={{width:"100px"}} onClick={(e)=>onUpdateCustomerHandler(e)}>저장</button>
            <Link to={`/Admin/CustomerList`} style={{width:"100px"}} className="btn line">목록</Link>
          </div>
          {Number(cs_idx) === 0? 
            <div>
              <p>※ 노선의 등록은 거래처를 먼저 등록하신 후에 등록이 가능합니다.</p>
            </div>
          :
            <div>
              <h2 style={{fontSize:"16px",margin:"20px 0px 10px"}}>노선 정보</h2>
              <div className="main-box">
                <table className="write">
                  <colgroup>
                    <col width="15%"></col>
                    <col width="20%"></col>
                    <col width="15%"></col>
                    <col width="50%"></col>
                  </colgroup>
                  <thead></thead>
                  <tbody>
                    <tr>
                      <th>상차지명</th>
                      <td><input type="text" name="csl_riding_name" value={varCustomerLineInfo.csl_riding_name} style={{width:"100%"}} onChange={(e)=>onCustomerLineInfoHandler(e)}/></td>
                      <th>상차지주소</th>
                      <td><input type="text" name="csl_riding_address" value={varCustomerLineInfo.csl_riding_address} style={{width:"100%"}} onChange={(e)=>onCustomerLineInfoHandler(e)}/></td>
                    </tr>
                    <tr>
                      <th>경유지명</th>
                      <td><input type="text" name="csl_middle_name" value={varCustomerLineInfo.csl_middle_name} style={{width:"100%"}} onChange={(e)=>onCustomerLineInfoHandler(e)}/></td>
                      <th>경유지주소</th>
                      <td><input type="text" name="csl_middle_address" value={varCustomerLineInfo.csl_middle_address} style={{width:"100%"}} onChange={(e)=>onCustomerLineInfoHandler(e)}/></td>
                    </tr>
                    <tr>
                      <th>하차지명</th>
                      <td><input type="text" name="csl_quit_name" value={varCustomerLineInfo.csl_quit_name} style={{width:"100%"}} onChange={(e)=>onCustomerLineInfoHandler(e)}/></td>
                      <th>하차지주소</th>
                      <td><input type="text" name="csl_quit_address" value={varCustomerLineInfo.csl_quit_address} style={{width:"100%"}} onChange={(e)=>onCustomerLineInfoHandler(e)}/></td>
                    </tr>
                    <tr>
                      <th>단가</th>
                      <td><input type="text" name="csl_cost" value={addThousandPoint(varCustomerLineInfo.csl_cost)} style={{width:"100%",textAlign:"center"}} onChange={(e)=>onCustomerLineInfoHandler(e)}/></td>
                      <td colSpan={2}><button className="btn" style={{width:"70px"}} onClick={(e)=>onUpdateCustomerLineHandler(e)}>{varCustomerLineInfo.csl_idx===0?"등록":"저장"}</button></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="main-box">
                <table className="list">
                  <colgroup>
                    <col width="5%"></col>
                    <col width="8%"></col>
                    <col width="16%"></col>
                    <col width="7%"></col>
                    <col width="16%"></col>
                    <col width="7%"></col>
                    <col width="16%"></col>
                    <col width="10%"></col>
                    <col width="15%"></col>
                    </colgroup>
                  <thead>
                    <tr><th>번호</th><th>상차지명</th><th>상차지주소</th><th>경유지명</th><th>경유지주소</th><th>하차지명</th><th>하차지주소</th><th>단가</th><th>관리</th></tr>
                  </thead>
                  <tbody>
                    {varCustomerLines?.length===0?<tr><td colSpan={9}>등록된 노선이 없습니다.</td></tr>
                    :varCustomerLines.map((lines,i)=>(
                      <tr key={"lines_"+i}>
                        <td>{varCustomerLines.length-i}</td>
                        <td>{lines.csl_riding_name}</td>
                        <td>{lines.csl_riding_address}</td>
                        <td>{lines.csl_middle_name}</td>
                        <td>{lines.csl_middle_address}</td>
                        <td>{lines.csl_quit_name}</td>
                        <td>{lines.csl_quit_address}</td>
                        <td>{addThousandPoint(lines.csl_cost)}</td>
                        <td>
                          <button className="btn" style={{width:"70px"}} onClick={(e)=>onEditCustomerLineHandler(e,lines.csl_idx)}>수정</button>
                          <button className="btn line" style={{width:"70px"}} onClick={(e)=>onDeleteCustomerLineHandler(e,lines.csl_idx)}>삭제</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  );
}

export default CustomerDetail;